// extracted by mini-css-extract-plugin
export default {"wrapper":"TermsAndConditionsView_wrapper__p64tj","fade":"TermsAndConditionsView_fade__Rjtm3","tabContent":"TermsAndConditionsView_tabContent__5oOJt"};